module.exports = global["Modernizr"] = require("-!/Users/saptarshi/pagehits/repo/pagehits-client/web/node_modules/modernizr-loader/index.js!/Users/saptarshi/pagehits/repo/pagehits-client/web/node_modules/json-loader/index.js!./modernizrrc.json");


//////////////////
// WEBPACK FOOTER
// ../config/modernizrrc.json-exposed
// module id = 849
// module chunks = 1